export default "__VITE_ASSET__DmSLwo3b__"